// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-btn:not(.v-btn--round).v-size--x-small[data-v-586b1880]{padding:0 15.625px}.v-btn:not(.v-btn--round).v-size--small[data-v-586b1880]{padding:0 21.875px}.v-btn:not(.v-btn--round).v-size--default[data-v-586b1880]{padding:0 28.125px}.v-btn:not(.v-btn--round).v-size--large[data-v-586b1880]{padding:0 34.375px}.v-btn:not(.v-btn--round).v-size--x-large[data-v-586b1880]{padding:0 40.625px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
